import axios from "axios";
import config from "config/APIEndpoints";

const BASE_API_URL = config.getEndpoint();
const ADMIN_API_URL = BASE_API_URL + "/api/v1";
const PMO_ENDPOINT = ADMIN_API_URL + "/pmo";

const feBaseLink = {
  applicationForm: "https://caarya-apps.web.app",
  caaryaLive: "https://caarya.live",
};

export { BASE_API_URL, feBaseLink };

// Util
export const getHeader = () => {
  return {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
  };
};

export const getMultipartHeader = () => {
  return {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "content-type": "multipart/form-data",
    },
  };
};

export const instance = axios.create({
  baseURL: ADMIN_API_URL,
});

export const pmoInstance = axios.create({
  baseURL: PMO_ENDPOINT,
});
